module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"engineRebuildingOrders":"Órdenes de la Rectificadora"},"en":{"engineRebuildingOrders":"Engine Rebuilding Orders"}}')
  delete Component.options._Ctor
}
